const WATCH_STATES = Object.freeze({
  SIGNED_OUT: "signed-out",
  ERROR: "error",
  RECONNECTING: "reconnecting",
  CONNECTING: "connecting",
  LIVE: "live",
  INTERMISSION: "intermission",
  ENDED: "ended",
  WAITING: "waiting",
});

const BROADCAST_PAUSED = "paused";
const BROADCAST_LIVE = "live";

function resolveWatchState({
  signedIn = true, error = "", connecting = false, reconnecting = false, hasVideo = false, broadcastStatus = "idle", ended = false,
} = {}) {
  if (ended) {
    return WATCH_STATES.ENDED;
  }
  if (!signedIn) {
    return WATCH_STATES.SIGNED_OUT;
  }
  if (error) {
    return WATCH_STATES.ERROR;
  }
  if (broadcastStatus === BROADCAST_PAUSED) {
    return WATCH_STATES.INTERMISSION;
  }
  if (reconnecting) {
    return WATCH_STATES.RECONNECTING;
  }
  if (hasVideo) {
    return WATCH_STATES.LIVE;
  }
  if (connecting) {
    return WATCH_STATES.CONNECTING;
  }
  if (broadcastStatus === BROADCAST_LIVE) {
    return WATCH_STATES.RECONNECTING;
  }

  return WATCH_STATES.WAITING;
}

const COPY = {
  [WATCH_STATES.SIGNED_OUT]: { title: "Sign in to watch", subtitle: "The stream plays once you're signed in to this site." },
  [WATCH_STATES.ERROR]: { title: "The stream is unavailable", subtitle: "Something went wrong reaching the stream. Try refreshing the page." },
  [WATCH_STATES.RECONNECTING]: { title: "Reconnecting", subtitle: "The connection dropped for a moment. The stream will be back shortly." },
  [WATCH_STATES.CONNECTING]: { title: "Connecting", subtitle: "Joining the stream now." },
  [WATCH_STATES.LIVE]: { title: "", subtitle: "" },
  [WATCH_STATES.INTERMISSION]: { title: "We'll be right back", subtitle: "The host has stepped away for a moment. Stay here, the stream resumes on its own." },
  [WATCH_STATES.ENDED]: { title: "This event has ended", subtitle: "Thanks for watching." },
  [WATCH_STATES.WAITING]: { title: "Waiting for the broadcaster", subtitle: "The stream will start automatically once they go live." },
};

function describeWatchState(state, { intermissionText = "" } = {}) {
  const copy = COPY[state] || COPY[WATCH_STATES.WAITING];
  if (state === WATCH_STATES.INTERMISSION && String(intermissionText || "").trim()) {
    return { title: String(intermissionText).trim(), subtitle: copy.subtitle };
  }

  return { ...copy };
}

module.exports = { WATCH_STATES, resolveWatchState, describeWatchState };
